<template>
    <div class="c-free-checkbox" v-show="display">
        <input class="c-free-checkbox__input" type="checkbox" :name="name" :id="inputId" :value="value" ref="input" @change="updateSelection"
            :checked="checked">
        <label class="c-free-checkbox__label" :for="inputId">{{ label }}</label>
    </div>
</template>


<script>
    export default {
        name: "CheckBox",
        props: ['name', 'label', 'value', 'type', 'checked'],
        data() {
            return {
                display: true,
            }
        },
        computed: {
            inputId() {
                return this.value + 'FilterID'
            }
        },
        methods: {
            updateSelection(e) {
                this.$emit('checkboxEvent', {
                    checked: e.target.checked,
                    value: e.target.value,
                    type: this.type
                })
            }
        }
    }
</script>

<style scoped>

</style>